import { render, staticRenderFns } from "./TableIvAddons.vue?vue&type=template&id=146d0a54"
import script from "./TableIvAddons.vue?vue&type=script&lang=js"
export * from "./TableIvAddons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports